import { RowExportTypeExcel } from "types";
import { excel } from "utils";
import { CurrentStockPerformenceResponse } from "../../types/CurrentStockPerformence";


export function ExportExcelStockPerformanc({ dataList }: {
  dataList: CurrentStockPerformenceResponse['data'],
}) {
  const columns = [
    { header: 'NO', key: 'no', width: 5 },
    { header: 'CODE', key: 'code', width: 10 },
    { header: 'PRODUCT NAME', key: 'product_name', width: 20 },
    { header: 'SOH', key: 'soh', width: 20 },
    { header: 'QTY ORDER', key: 'qty_order', width: 20 },
    { header: 'STOCK IN', key: 'qty_in', width: 20 },
    { header: 'STOCK OUT', key: 'qty_out', width: 20 },
    { header: 'COMMITED', key: 'commited', width: 20 },
  ];

  const dataMap: RowExportTypeExcel[] = dataList.map((item, index: number) => {

    return {
      no: index + 1,
      code: item.product_barcode,
      product_name: item.product_name,
      soh: {
        text: Number(item.soh),
        style: {
          numFmt: '#,##0',
        }
      },
      qty_order: {
        text: Number(item.qty_order),
         style: {
          numFmt: '#,##0',
        }
      },
      qty_in: {
        text: Number(item.stock_in),
         style: {
          numFmt: '#,##0',
        }
      },
      qty_out: {
        text: Number(item.stock_out),
         style: {
          numFmt: '#,##0',
        }
      },
      commited: {
        text: Number(item.committed),
         style: {
          numFmt: '#,##0',
        }
      },
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: 'INVENTORY',
    title: 'CURRENT STOCK PERFORMANCE',
    fileName: 'Current_Stock_Performance',
  });
}

